module.exports = __webpack_public_path__ + "img/LCD_connection_block.e4b2ecb0.png";